// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Za9e","clinicsSelect":"styles_clinicsSelect__2C9Bu"};